import WelcomeSection from "./WelcomeSection";

export default WelcomeSection;
